import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@goodday-clone/ui'
import { GitBranch, ArrowLeft } from 'lucide-react'

export default function GanttPage() {
  const navigate = useNavigate()
  return (
    <div className="space-y-6 max-w-full mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3.5">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-[#6825F5] to-[#7C3AED] text-white shadow-sm shadow-purple-200 transition-all hover:shadow-md hover:shadow-purple-300/50"
            aria-label="Back"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
              <GitBranch className="h-6 w-6 text-primary" />
              Waterfall / Gantt Chart
            </h1>
            <p className="text-sm text-muted-foreground">Plan your project timeline with Gantt-style task scheduling</p>
          </div>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Timeline View</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center min-h-[300px] text-muted-foreground gap-3">
            <GitBranch className="h-12 w-12 opacity-30" />
            <p className="text-sm font-medium">No tasks scheduled yet</p>
            <p className="text-xs">Add tasks to your projects to see them on the Gantt chart</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
